import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    id: 1,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715267/project_Ecomm/ecomm__downscaled/air2_lsfzfb_kp0oqw.jpg",
    title: "NIKE",
    productName: "Jordan 1 UNC Chicago",
    price: 53000,
    brand: "nike",
    size: 4.5,
    categoryName: "non-fiction",
  },
  {
    _id: uuid(),
    id: 2,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product5_qcebfo_l1akyx.jpg",
    title: "NIKE",
    productName: "Jordan 1 Black Toe",
    price: 27000,
    brand: "nike-sportswear",
    size: 7,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 3,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1647955192/project_Ecomm/col6_hhdkwr.jpg",
    title: "NIKE",
    productName: "Jordan 1 Retro OG",
    price: 23000,
    brand: "Nikelab",
    size: 9,
    categoryName: "fiction",
  },
  {
    _id: uuid(),
    id: 4,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product4_vr2ao0_e2cvjt.jpg",
    title: "NIKE",
    productName: "Jordan 1 Shadow",
    price: 30000,
    brand: "nikelab",
    size: 5,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 5,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715267/project_Ecomm/ecomm__downscaled/air1_jifei7_u8bfq6.jpg",
    title: "NIKE",
    productName: "Jordan 1 X OFF-WHITE",
    price: 83000,
    brand: "jordanxoffwhite",
    size: 9,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 6,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product2_znlj6f_gb2byu.jpg",
    title: "NIKE",
    productName: "Jordan 1 Powder Blue",
    price: 16000,
    brand: "nikelab",
    size: 6,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 7,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product1_omgado_k6stkl.jpg",
    title: "NIKE",
    productName: "Jordan 1 x Travis Scott",
    price: 99000,
    brand: "jordan",
    size: 6,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 8,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product6_ikjb4j_wlc8fc.jpg",
    title: "NIKE",
    productName: "Jordan 1 Clean Slate",
    price: 18000,
    brand: "jordan",
    size: 9,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 9,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715267/project_Ecomm/ecomm__downscaled/aforce1_h0lbzs_syzg6m.jpg",
    title: "NIKE",
    productName: "Air Force 1 Colours",
    price: 12000,
    brand: "nikepro",
    size: 5,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 10,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715267/project_Ecomm/ecomm__downscaled/aforce2_ope3pt_ugel9x.jpg",
    title: "NIKE",
    productName: "Air Force 1 Gray",
    price: 10000,
    brand: "nike",
    size: 7,
    categoryName: "horror",
  },
  {
    _id: uuid(),
    id: 11,
    image: "https://res.cloudinary.com/sameep1/image/upload/v1655715266/project_Ecomm/ecomm__downscaled/product3_samqkp_b6f3em.jpg",
    title: "NIKE",
    productName: "Jordan 5 Purple",
    price: 25000,
    brand: "jordan",
    size: 7,
    categoryName: "horror",
  },
];
